class Negotiation {
  // decorates app/reverb_api/v3/representers/negotiation_representer.rb json
  constructor(json) {
    this.json = json;

    this.id = json.id;
    this.state = json.state;
    this.isActionable = json.actionable;
    this.youLastInitiated = json.you_last_initiated;
    this.offersCount = json.offers_count;
    this.otherPartyName = json.other_party_name;
    this.lastOfferedPrice = json.last_offered_price;
  }

  get isActive() {
    return this.state === 'active';
  }

  get isRejected() {
    return this.state === 'rejected';
  }

  get isCountered() {
    return this.offersCount > 1;
  }

  get displayPrice() {
    return this.lastOfferedPrice.display.display;
  }
}

export default Negotiation;



// WEBPACK FOOTER //
// ./javascripts/components/negotiations/negotiation.js